import dayjs from "dayjs";
import {all, fork, put, takeLatest} from "redux-saga/effects";
import {
  createAppointmentSuccess,
  deleteAppointmentSuccess,
  getAppointmentsAgendaFailed,
  getAppointmentsAgendaSuccess,
  getAppointmentsByDateFailed,
  getAppointmentsByDateSuccess,
  getAppointmentSuccess,
  updateAppointmentSuccess,
} from 'redux/actions';
import {
  APPOINTMENTS_CREATE,
  APPOINTMENTS_DELETE,
  APPOINTMENTS_GET,
  APPOINTMENTS_GET_AGENDA,
  APPOINTMENTS_GET_BY_DATES,
  APPOINTMENTS_UPDATE,
} from 'redux/constants/Appointments';
import EstService from 'services/EstService';
import NotificationService from 'services/NotificationService';

export function* getAppointments() {
	yield takeLatest(APPOINTMENTS_GET_BY_DATES, function* ({ start, end }) {
		try {
			const res = yield EstService.getAppointments(start, end);
			if (res && res.data) {
				yield put(getAppointmentsByDateSuccess(res.data));
			} else {
				yield put(getAppointmentsByDateFailed());
			}
		} catch (err) {
			console.log(err);
		}
	});
}

export function* getAppointmentsAgenda() {
	yield takeLatest(APPOINTMENTS_GET_AGENDA, function* ({ date }) {
		try {
			const start = dayjs(date).format('YYYY-MM-DD HH:mm:ss');
			const end = dayjs(date).endOf('month').format('YYYY-MM-DD HH:mm:ss');

			const res = yield EstService.getAppointments(start, end);
			if (res && res.data) {
				yield put(
					getAppointmentsAgendaSuccess(
						res.data
							? res.data
									.sort((a, b) => {
										if (
											dayjs(a.from, 'YYYY-MM-DD HH:mm:ss').isAfter(
												dayjs(b.from, 'YYYY-MM-DD HH:mm:ss')
											)
										) {
											return 1;
										} else if (
											dayjs(a.from, 'YYYY-MM-DD HH:mm:ss').isBefore(
												dayjs(b.from, 'YYYY-MM-DD HH:mm:ss')
											)
										) {
											return -1;
										} else {
											return 0;
										}
									})
									.slice(0, 7)
							: []
					)
				);
			} else {
				yield put(getAppointmentsAgendaFailed());
			}
		} catch (err) {
			console.log(err);
		}
	});
}

export function* getAppointment() {
	yield takeLatest(APPOINTMENTS_GET, function* ({ id }) {
		try {
			const res = yield EstService.getAppointment(id);
			if (res && res.data) {
				yield put(getAppointmentSuccess(res.data));
			}
		} catch (err) {
			console.log(err);
		}
	});
}

export function* createAppointment() {
	yield takeLatest(APPOINTMENTS_CREATE, function* ({ data }) {
		try {
			const res = yield EstService.createAppointment(data);
			NotificationService.success('Appointment created');

			if (res && res.data) {
				yield put(createAppointmentSuccess(res.data));
			}
		} catch (err) {
			console.log(err);
		}
	});
}

export function* updateAppointment() {
	yield takeLatest(APPOINTMENTS_UPDATE, function* ({ id, data }) {
		try {
			const res = yield EstService.updateAppointment(id, data);

			if (res && res.data) {
				yield put(updateAppointmentSuccess(res.data));
			}
		} catch (err) {
			console.log(err);
		}
	});
}

export function* deleteAppointment() {
  yield takeLatest(APPOINTMENTS_DELETE, function* ({ id }) {
    try {
      yield EstService.deleteAppointment(id);
      yield put(deleteAppointmentSuccess(id));
      NotificationService.success('Appointment deleted');
    } catch (err) {
      console.log(err)
    }
  })
}

export default function* invoicesSaga() {
  yield all([
    fork(getAppointments),
    fork(getAppointmentsAgenda),
    fork(getAppointment),
    fork(createAppointment),
    fork(updateAppointment),
    fork(deleteAppointment),
  ]);
}